import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Account, Shop } from '@motra/shared';

interface AuthState {
  token: string | null;
  user: User | null;
  account: Account | null;
  shop: Shop | null;
  isAdmin: boolean;

  setAuth: (data: {
    token: string;
    user: User;
    account: Account;
    shop?: Shop | null;
  }) => void;

  logout: () => void;
  setShop: (shop: Shop) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      account: null,
      shop: null,
      isAdmin: false,

      setAuth: ({ token, user, account, shop }) =>
        set({
          token,
          user,
          account,
          shop: shop ?? null,
          isAdmin: user.admin >= 1,
        }),

      logout: () =>
        set({
          token: null,
          user: null,
          account: null,
          shop: null,
          isAdmin: false,
        }),

      setShop: (shop) => set({ shop }),
    }),
    {
      name: 'motra_auth',
    },
  ),
);
